module.exports = __webpack_public_path__ + "static/media/equal-housing-opportunity.7b48e51c.svg";